import home from '../views/subPage/home';
import aboutUs from '../views/subPage/aboutUs';
import index from '../views/index.vue';
import notFound from '../views/notFound';

const routes = [
  // {
  //   path: '/index', name: 'index', component: index, children: [
  //     { path: 'home', name: 'home', component: home },
  //     { path: 'aboutUs', name: 'aboutUs', component: aboutUs },
  //   ]
  // },

  { path: '/:pathMatch(.*)*', name: 'notFound', component: notFound },
];

const whiteList = [
  /^\/login/, /^\/403/
];

export {
  routes,
  whiteList,
};
